export const DESIGN_AREA_SIDEBAR_MENUS = {
  TEMPLATES_TAB_TOOLTIP: { key: 'TEMPLATES_TAB_TOOLTIP', value: 'Templates' },
  ELEMENTS_TAB_TOOLTIP: { key: 'ELEMENTS_TAB_TOOLTIP', value: 'Elements' },
  TEXT_TAB_TOOLTIP: { key: 'TEXT_TAB_TOOLTIP', value: 'Text' },
  UPLOADS_TAB_TOOLTIP: { key: 'UPLOADS_TAB_TOOLTIP', value: 'Uploads' },
  FOLDERS_TAB_TOOLTIP: { key: 'FOLDERS_TAB_TOOLTIP', value: 'Folders' },
  SETTINGS_TAB_TOOLTIP: { key: 'SETTINGS_TAB_TOOLTIP', value: 'Settings' },
  TRANSLATE_TAB_TOOLTIP: { key: 'TRANSLATE_TAB_TOOLTIP', value: 'Translate' },
  SHOW_VARIABLES_TAB_TOOLTIP: { key: 'SHOW_VARIABLES_TAB_TOOLTIP', value: 'Show Variables' },
  REFERENCED_ELEMENTS_TOOLTIP: { key: 'REFERENCED_ELEMENTS_TOOLTIP', value: 'Referenced Elements' },
  EMAIL_SETTINGS_TAB_TOOLTIP: { key: 'EMAIL_SETTINGS_TAB_TOOLTIP', value: 'Email Settings' },
  MASTER_ELEMENTS_TAB_TOOLTIP: { key: 'MASTER_ELEMENTS_TAB_TOOLTIP', value: 'Master Elements' },
  HIDE_SIDEBAR_TOOLTIP: { key: 'HIDE_SIDEBAR_TOOLTIP', value: 'Hide' },
  TEXT_ELEMENT_INFO_TEXT: {
    key: 'TEXT_ELEMENT_INFO_TEXT',
    value: 'Drag the text to editor section to create an element',
  },
  ACCESSIBILITY_DESIGN: { key: 'ACCESSIBILITY_DESIGN', value: 'Accessible Design' },
  PREVIEW_DOWNLOAD_TOOLTIP: { key: 'PREVIEW_DOWNLOAD_TOOLTIP', value: 'Preview & Download' },
  PREVIEW_AND_SEND_EMAIL_TOOLTIP: { key: 'PREVIEW_AND_SEND_EMAIL_TOOLTIP', value: 'Preview & Send Email' },
  EMAIL_ATTACHMENT_SETTINGS_TAB_TOOLTIP: { key: 'EMAIL_ATTACHMENT_SETTINGS_TAB_TOOLTIP', value: 'Attachments & Subject' },
  CHANNEL_TOOLTIP: { key: 'CHANNELS_TOOLTIP', value: 'Channels' },
  EMAIL_TITLE: { key: 'EMAIL_TITLE', value: 'MAIL STUDIO' },
  INSERTS_TOOLTIP: { key: 'INSERTS_TOOLTIP', value: 'Inserts' },
  PREVIEW_TOOLTIP: { key: 'PREVIEW_TOOLTIP', value: 'Preview' },
  VERSIONS_TOOLTIP: { key: 'VERSIONS_TOOLTIP', value: 'Versions' },
};

export const DESIGN_AREA_TEMPLATES_TAB = {
  CREATE_NEW_TEMPLATE_BUTTON: { key: 'CREATE_NEW_TEMPLATE_BUTTON', value: 'Create New Template' },
  MY_DESIGNS_TAB_TITLE: { key: 'MY_DESIGNS_TAB_TITLE', value: 'My designs' },
  MASTER_DESIGNS_TAB_TITLE: { key: 'MASTER_DESIGNS_TAB_TITLE', value: 'Master' },
  SEARCH_TEMPLATES_PLACEHOLDER: { key: 'SEARCH_TEMPLATES_PLACEHOLDER', value: 'Search Templates' },
  SEARCH_BY_CATEGORY_LABEL: { key: 'SEARCH_BY_CATEGORY_LABEL', value: 'By Category' },
  CLEAR_ALL_FILTER_ACTION: { key: 'CLEAR_ALL_FILTER_ACTION', value: 'Clear All' },
  APPLY_FILTERS_BUTTON: { key: 'APPLY_FILTERS_BUTTON', value: 'Apply Filters' },
  ALL_CATEGORY_DROPDOWN_OPTION: { key: 'ALL_CATEGORY_DROPDOWN_OPTION', value: 'All' },
  SEE_ALL_TEMPLATES_ACTION: { key: 'SEE_ALL_TEMPLATES_ACTION', value: 'See All' },
  TEMPLATES_FOUND_COUNT: {
    key: 'TEMPLATES_FOUND_COUNT',
    value: 'We found {{templatesCount}} results based on your search',
  },
  TEMPLATES_LIST_EMPTY: { key: 'TEMPLATES_LIST_EMPTY', value: 'Templates list is empty.' },
  CLICK: { key: 'CLICK', value: 'Click' },
  HERE: { key: 'HERE', value: 'here' },
  EMPTY_LIST_CREATE_NEW_TEMPLATE: {
    key: 'EMPTY_LIST_CREATE_NEW_TEMPLATE',
    value: 'to create new template',
  },
  TEMPLATE_EDIT_DROPDOWN_OPTION: { key: 'TEMPLATE_EDIT_DROPDOWN_OPTION', value: 'Edit' },
  TEMPLATE_DELETE_DROPDOWN_OPTION: { key: 'TEMPLATE_DELETE_DROPDOWN_OPTION', value: 'Delete' },
  TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION: {
    key: 'TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION',
    value: 'Manage Tags',
  },
  TEMPLATE_PREVIEW_TOOLTIP: { key: 'TEMPLATE_PREVIEW_TOOLTIP', value: 'Preview' },
  LOADING_MORE_TEMPLATES_TEXT: { key: 'LOADING_MORE_TEMPLATES_TEXT', value: 'Loading...' },
  APPLY_ALL_PAGES_BUTTON: { key: 'APPLY_ALL_PAGES_BUTTON', value: 'Apply all pages' },
  PAGE_NUMBER_LABEL: { key: 'PAGE_NUMBER_LABEL', value: 'Page {{PageNum}} of' },
  PAGE_NUM: { key: 'PAGE_NUM', value: 'Page' },
  GOT_ALL_RESULTS: { key: 'GOT_ALL_RESULTS', value: 'You have got all search results' },
  NO_TEMPLATES_AVAILABLE: { key: 'NO_TEMPLATES_AVAILABLE', value: 'No templates available' },
  TEMPLATE_EDITED_ON: { key: 'TEMPLATE_EDITED_ON', value: 'Edited on ' },
  TEMPLATE_DELETE_CONFIRMATION_TITLE: {
    key: 'TEMPLATE_DELETE_CONFIRMATION_TITLE',
    value: 'Delete template',
  },
  TEMPLATE_DELETE_CONFIRMATION: {
    key: 'TEMPLATE_DELETE_CONFIRMATION',
    value: 'Are you sure you wish to delete',
  },
  TEMPLATE_DELETE_NAME: { key: 'TEMPLATE_DELETE_NAME', value: 'template' },
  DELETE_ELEMENT_NAME: { key: 'DELETE_ELEMENT_NAME', value: 'element' },
  TEMPLATE_DELETE_UNDER: { key: 'TEMPLATE_DELETE_UNDER', value: 'under' },
  TEMPLATE_DELETE_CATEGORY: { key: 'TEMPLATE_DELETE_CATEGORY', value: 'category' },
  DELETE_TEMPLATE_BUTTON: { key: 'DELETE_TEMPLATE_BUTTON', value: 'Delete' },
  CANCEL_DELETING_TEMPLATE_BUTTON: { key: 'CANCEL_DELETING_TEMPLATE_BUTTON', value: 'Cancel' },
  DELETING_BUTTON: { key: 'DELETING_BUTTON', value: 'Deleting' },
  FETCHING_RECORDS_ERROR_MESSAGE: {
    key: 'FETCHING_RECORDS_ERROR_MESSAGE',
    value: 'Error Fetching records. Please try again or contact support.'
  },
  MY_DESIGNS_TABS_TITLE: { key: 'MY_DESIGNS_TAB_TITLE', value: 'My Designs' },
  MASTER_DESIGNS_TABS_TITLE: { key: 'MASTER_DESIGNS_TAB_TITLE', value: 'Master Designs' },
  SEARCH_BY_LANGUAGE_LABEL: { key: 'SEARCH_BY_LANGUAGE_LABEL', value: 'By language' },
  FILTER_POPUP_LABEL: { key: 'FILTER_POPUP_LABEL', value: 'Filters' },
  STANDALONE_FLOW_DELETE_SUCCESS_MESSAGE: {
    key: 'STANDALONE_FLOW_DELETE_SUCCESS_MESSAGE', value: 'Reusable page deleted successfully'
  },
  STANDALONE_FLOW_DELETE_FAILURE_MESSAGE: {
    key: 'STANDALONE_FLOW_DELETE_FAILURE_MESSAGE', value: 'An error occured while trying to delete the standalone flow'
  },
  STANDALONE_BLOCK_DELETE_SUCCESS_MESSAGE: {
    key: 'STANDALONE_BLOCK_DELETE_SUCCESS_MESSAGE', value: 'Reusable section deleted successfully'
  },
  STANDALONE_BLOCK_DELETE_FAILURE_MESSAGE: {
    key: 'STANDALONE_BLOCK_DELETE_FAILURE_MESSAGE', value: 'An error occured while trying to delete the standalone block'
  },
  TEMPLATE_DELETE_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_DELETE_SUCCESS_MESSAGE', value: 'Template deleted successfully'
  },
  EMAIL_DELETE_SUCCESS_MESSAGE: {
    key: 'EMAIL_DELETE_SUCCESS_MESSAGE', value: 'Email deleted successfully'
  },
  SHORT_MESSAGE_DELETE_SUCCESS_MESSAGE: {
    key: 'SHORT_MESSAGE_DELETE_SUCCESS_MESSAGE', value: 'Message deleted successfully'
  },
  ELEMENT_USED_WARN_MESSAGE: {
    key: 'ELEMENT_USED_WARN_MESSAGE',
    value: 'Resource is used in templates. Please remove the usages to delete resource.'
  },
  DOCUMENT_FETCH_FAIL_MESSAGE:{
    key:'DOCUMENT_FETCH_FAIL_MESSAGE',
    value: 'Unable to retrieve document details at the moment. Please try again later'
  }
};

export const DESIGN_AREA_ELEMENTS_TAB = {
  REUSABLE_ELEMENT_TAB_TITLE: { key: 'REUSABLE_ELEMENT_TAB_TITLE', value: 'Reusables' },
  REFERENCED_ELEMENT_TAB_TITLE: { key: 'REFERENCED_ELEMENT_TAB_TITLE', value: 'Referenced' },
  MASTER_ELEMENT_TAB_TITLE: { key: 'MASTER_ELEMENT_TAB_TITLE', value: 'Master' },
  SEARCH_ELEMENTS_PLACEHOLDER: { key: 'SEARCH_ELEMENTS_PLACEHOLDER', value: 'Search Elements' },
  SEARCH_BY_CATEGORY_LABEL: { key: 'SEARCH_BY_CATEGORY_LABEL', value: 'By Category' },
  CLEAR_ALL_FILTER_ACTION: { key: 'CLEAR_ALL_FILTER_ACTION', value: 'Clear All' },
  APPLY_FILTERS_BUTTON: { key: 'APPLY_FILTERS_BUTTON', value: 'Apply Filters' },
  ALL_CATEGORY_DROPDOWN_OPTION: { key: 'ALL_CATEGORY_DROPDOWN_OPTION', value: 'All' },
  SEE_ALL_ELEMENTS_ACTION: { key: 'SEE_ALL_ELEMENTS_ACTION', value: 'See All' },
  ELEMENTS_FOUND_COUNT: {
    key: 'ELEMENTS_FOUND_COUNT',
    value: 'We found {{elementsCount}} results based on your search',
  },
  DELETE_ELEMENT_BUTTON: { key: 'DELETE_ELEMENT_BUTTON', value: 'Delete' },
  CANCEL_DELETING_ELEMENT_BUTTON: { key: 'CANCEL_DELETING_ELEMENT_BUTTON', value: 'Cancel' },
  DELETING_BUTTON: { key: 'DELETING_BUTTON', value: 'Deleting' },
  ELEMENT_MANAGE_TAGS_DROPDOWN_OPTION: {
    key: 'ELEMENT_MANAGE_TAGS_DROPDOWN_OPTION',
    value: 'Manage Tags',
  },
  DELETE_ELEMENT_DROPDOWN_OPTION: {
    key: 'DELETE_ELEMENT_DROPDOWN_OPTION',
    value: 'Delete',
  },
  DELETE_ELEMENT_CONFIRMATION_TITLE: {
    key: 'DELETE_ELEMENT_CONFIRMATION_TITLE',
    value: 'Delete element',
  },
  DELETE_ELEMENT_CONFIRMATION: {
    key: 'DELETE_ELEMENT_CONFIRMATION',
    value: 'Are you sure you wish to delete',
  },
  DELETE_ELEMENT_NAME: { key: 'DELETE_ELEMENT_NAME', value: 'element under' },
  DELETE_ELEMENT_CATEGORY: { key: 'DELETE_ELEMENT_CATEGORY', value: 'category?' },
  GOT_ALL_RESULTS: { key: 'GOT_ALL_RESULTS', value: 'You have got all search results' },
  NO_ELEMENTS_AVAILABLE: { key: 'NO_ELEMENTS_AVAILABLE', value: 'No elements available' },
  ELEMENTS_LIST_EMPTY: { key: 'ELEMENTS_LIST_EMPTY', value: 'Elements list is empty. Use' },
  TEXT_ELEMENT: { key: 'TEXT_ELEMENT', value: 'Text' },
  TEXT_OR_IMAGE: { key: 'TEXT_OR_IMAGE', value: 'or' },
  IMAGE_UPLOAD: { key: 'IMAGE_UPLOAD', value: 'Upload' },
  CREATE_ELEMENTS: { key: 'CREATE_ELEMENTS', value: 'images to create elements' },
  GOT_ALL_RESULTS: { key: 'GOT_ALL_RESULTS', value: 'You have got all search results' },
  NO_ELEMENTS_AVAILABLE: { key: 'NO_ELEMENTS_AVAILABLE', value: 'No elements available' },
  ELEMENTS_LOADING: { key: 'ELEMENTS_LOADING', value: 'Loading...' },
};

export const DESIGN_AREA_UPLOADS_TAB = {
  DELETE_IMAGE_MODAL_DISPLAY_TEXT: { key: 'DELETE_IMAGE_MODAL_DISPLAY_TEXT', value: 'image' },
  UPLOADED_IMAGES_COUNT: { key: 'UPLOADED_IMAGES_COUNT', value: 'Uploaded' },
  UPLOAD_IMAGES_BUTTON: { key: 'UPLOAD_IMAGES_BUTTON', value: 'Upload images' },
  UPLOAD_IMAGE_TOOLTIP: { key: 'UPLOAD_IMAGE_TOOLTIP', value: 'Upload image' },
  GENERATE_IMAGES_BUTTON: { key: 'GENERATE_IMAGES_BUTTON', value: 'Generate images' },
  GENERATE_IMAGE_MODAL_TITLE: { key: 'GENERATE_IMAGE_MODAL_TITLE', value: 'Generate image' },
  GENERATE_IMAGE_PLACEHOLDER: {
    key: 'GENERATE_IMAGE_PLACEHOLDER',
    value: 'Imagine and tell us what you want in your image...',
  },
  GENERATE_IMAGE_WIDTH_LABEL: { key: 'GENERATE_IMAGE_WIDTH_LABEL', value: 'Width' },
  GENERATE_IMAGE_HEIGHT_LABEL: { key: 'GENERATE_IMAGE_HEIGHT_LABEL', value: 'Height' },
  GENERATE_BUTTON: { key: 'GENERATE_BUTTON', value: 'Generate' },
  DELETE_IMAGE_DROPDOWN_OPTION: { key: 'DELETE_IMAGE_DROPDOWN_OPTION', value: 'Delete' },
  DOWNLOAD_IMAGE_DROPDOWN_OPTION: { key: 'DOWNLOAD_IMAGE_DROPDOWN_OPTION', value: 'Download' },
  DELETE_IMAGE_MODAL_TITLE: { key: 'DELETE_IMAGE_MODAL_TITLE', value: 'Delete' },
  DELETE_BUTTON: { key: 'DELETE_BUTTON', value: 'Delete' },
  DELETING_BUTTON: { key: 'DELETING_BUTTON', value: 'Deleting' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  IMAGE_DELETE_CONFIRMATION: {
    key: 'IMAGE_DELETE_CONFIRMATION',
    value: 'Are you sure you wish to delete',
  },
  IMAGE_UNDER: { key: 'IMAGE_UNDER', value: 'under' },
  IMAGE_CATEGORY: { key: 'IMAGE_CATEGORY', value: 'category' },
  IMAGE_LOADING: { key: 'IMAGE_LOADING', value: 'Loading...' },
  IMAGE_DROP_AREA_PLACEHOLDER: {
    key: 'IMAGE_DROP_AREA_PLACEHOLDER',
    value: 'Just drag images here from your desktop to upload',
  },
  UPLOADED_IMAGE_FILE_EXTENSION_ERROR_MESSAGE: {
    key: 'UPLOADED_IMAGE_FILE_EXTENSION_ERROR_MESSAGE',
    value: 'Please upload only files of extension',
  },
  IMAGE_OK_TEXT: { key: 'IMAGE_OK_TEXT', value: 'ok' },
  SEARCH_PLACEHOLDER: { key: 'SEARCH_PLACEHOLDER', value: 'Search' },
  IMAGE_NOT_FOUND_MESSAGE: { key: 'IMAGE_NOT_FOUND_MESSAGE', value: "Sorry, we couldn't find that image." },
  IMAGE_DELETE_SUCCESS_MESSAGE: { key: 'IMAGE_DELETED_SUCCESS_MESSAGE', value: 'Image deleted successfully.' },
  IMAGE_DELETE_ERROR_MESSAGE: { key: 'IMAGE_DELETE_ERROR_MESSAGE', value: 'Failed to delete the image.' },
  IMAGE_ID_COPIED_SUCCESS: {key: 'IMAGE_ID_COPIED_SUCCESS', value:'Copied successfully'},
  COPY_ID:{key:'COPY_ID', value: 'Copy Id'}
};

export const DESIGN_AREA_TRANSLATION_TAB = {
  DELETE_TEMPLATE_BUTTON: { key: 'DELETE_TEMPLATE_BUTTON', value: 'Delete' },
  ADD_LANGUAGE_BUTTON: { key: 'ADD_LANGUAGE_BUTTON', value: 'Add' },
  TEMPLATE_AVAILABLE_IN_LANGUAGES: {
    key: 'TEMPLATE_AVAILABLE_IN_LANGUAGES',
    value: 'Template available in',
  },
  AVAILABLE_LANGUAGES: { key: 'AVAILABLE_LANGUAGES', value: 'Also available in' },
  NO_LANGUAGE_AVAILABLE: {
    key: 'NO_LANGUAGE_AVAILABLE',
    value: 'Sorry, language for the template is not detected / applicable',
  },
  TRANSLATE_TEMPLATE_SUCCESS_MESSAGE: {
    key: 'TRANSLATE_TEMPLATE_SUCCESS_MESSAGE',
    value: 'Translated template to {{name}}',
  },
  TRANSLATE_ELEMENT_SUCCESS_MESSAGE: {
    key: 'TRANSLATE_ELEMENT_SUCCESS_MESSAGE',
    value: 'Translated element to {{name}}',
  },
  TRANSLATE_ELEMENT_ERROR_MESSAGE: {
    key: 'TRANSLATE_ELEMENT_ERROR_MESSAGE',
    value: 'Could not translate element to {{name}}. Please check limit for translation key.',
  },
  TRANSLATE_TEMPLATE_ERROR_MESSAGE: {
    key: 'TRANSLATE_TEMPLATE_ERROR_MESSAGE',
    value: 'Could not translate template to {{name}}. Please check limit for translation key.',
  }
};

export const DESIGN_AREA_FOLDERS_TAB = {
  FOLDERS_TITLE: { key: 'FOLDERS_TITLE', value: 'Folders' },
  CREATE_NEW_FOLDER_BUTTON: { key: 'CREATE_NEW_FOLDER_BUTTON', value: 'Create New Folder' },
  CREATE_NEW_FOLDER_TOOLTIP: { key: 'CREATE_NEW_FOLDER_TOOLTIP', value: 'Create New Folder' },
  CREATE_NEW_SUB_FOLDER_TOOLTIP: { key: 'CREATE_NEW_SUB_FOLDER_TOOLTIP', value: 'Create' },
  LOADING_FOLDERS: { key: 'LOADING_FOLDERS', value: 'Loading...' },
  SUB_FOLDERS_COUNT_LABEL: { key: 'SUB_FOLDERS_COUNT_LABEL', value: 'Subfolders' },
  TEMPLATES_COUNT_LABEL: { key: 'TEMPLATES_COUNT_LABEL', value: 'Templates' },
  EDIT_FOLDER_DROPDOWN_OPTION: { key: 'EDIT_FOLDER_DROPDOWN_OPTION', value: 'Edit' },
  DELETE_FOLDER_DROPDOWN_OPTION: { key: 'DELETE_FOLDER_DROPDOWN_OPTION', value: 'Delete' },
  REMOVE_TEMPLATE_FROM_FOLDER_DROPDOWN_OPTION: {
    key: 'REMOVE_TEMPLATE_FROM_FOLDER_DROPDOWN_OPTION',
    value: 'Remove',
  },
  TEMPLATE_PREVIEW_TOOLTIP: { key: 'TEMPLATE_PREVIEW_TOOLTIP', value: 'Preview' },
  FOLDERS_LIST_EMPTY: { key: 'FOLDERS_LIST_EMPTY', value: 'Folder list is empty. Click' },
  EMPTY_FOLDERS: { key: 'EMPTY_FOLDERS', value: 'Folder is empty' },
  HERE: { key: 'HERE', value: 'here' },
  EMPTY_LIST_CREATE_NEW_FOLDER: {
    key: 'EMPTY_LIST_CREATE_NEW_FOLDER',
    value: 'to create new folder',
  },
  SAVE_BUTTON: { key: 'SAVE_BUTTON', value: 'Save' },
  SAVING_BUTTON: { key: 'SAVING_BUTTON', value: 'Saving' },
  SAVE_TO_FOLDER: { key: 'SAVE_TO_FOLDER', value: 'Save to this folder' },
  FOLDER_SAVED: { key: 'FOLDER_SAVED', value: 'Saved' },
  REPLACE_TEMPLATE_MODAL_TITLE: { key: 'REPLACE_TEMPLATE_MODAL_TITLE', value: 'Replace template' },
  REPLACE_TEMPLATE_YES_BUTTON: { key: 'REPLACE_TEMPLATE_YES_BUTTON', value: 'Yes' },
  REPLACE_TEMPLATE_NO_BUTTON: { key: 'REPLACE_TEMPLATE_NO_BUTTON', value: 'No' },
  REPLACE_TEMPLATE_CONFIRMATION: {
    key: 'REPLACE_TEMPLATE_CONFIRMATION',
    value: 'Are you sure to replace the existing template ?',
  },
  DELETE_FOLDER_MODAL_TITLE: { key: 'DELETE_FOLDER_MODAL_TITLE', value: 'Delete Folder' },
  REMOVE_TEMPLATE_MODAL_TITLE: { key: 'REMOVE_TEMPLATE_MODAL_TITLE', value: 'Remove Template' },
  CANCEL_DELETE_FOLDER_BUTTON: { key: 'CANCEL_DELETE_FOLDER_BUTTON', value: 'Cancel' },
  REMOVE_TEMPLATE_BUTTON: { key: 'REMOVE_TEMPLATE_BUTTON', value: 'Remove' },
  REMOVING_BUTTON: { key: 'REMOVING_BUTTON', value: 'Removing' },
  DELETE_FOLDER_BUTTON: { key: 'DELETE_FOLDER_BUTTON', value: 'Delete' },
  DELETING_FOLDER_BUTTON: { key: 'DELETING_FOLDER_BUTTON', value: 'Deleting' },
  REMOVE_TEMPLATE: { key: 'REMOVE_TEMPLATE', value: 'Remove' },
  DELETE_FOLDER: { key: 'DELETE_FOLDER', value: 'Delete' },
  FOLDER_DELETE_CONFIRMATION: {
    key: 'FOLDER_DELETE_CONFIRMATION',
    value: 'Are you sure you wish to',
  },
  REMOVE_TEMPLATE_NAME: { key: 'REMOVE_TEMPLATE_NAME', value: 'Template' },
  DELETE_FOLDER_NAME: { key: 'DELETE_FOLDER_NAME', value: 'Folder?' },
  FOLDER_UNDER: { key: 'FOLDER_UNDER', value: 'under' },
  FOLDER_HAVE: { key: 'FOLDER_HAVE', value: 'which is having' },
  FOLDER_ADDED_SUCCESS_MESSAGE: {
    key: 'FOLDER_ADDED_SUCCESS_MESSAGE',
    value: 'FolderElement Added Succesfully',
  },
  FOLDER_DELETED_SUCCESS_MESSAGE: {
    key: 'FOLDER_DELETED_SUCCESS_MESSAGE',
    value: 'folder deleted successfully',
  },
  TEMPLATE_DELETED_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_DELETED_SUCCESS_MESSAGE',
    value: 'Template deleted successfully',
  },
  TEMPLATE_REMOVED_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_REMOVED_SUCCESS_MESSAGE',
    value: 'Template was removed from the folder Successfully',
  },
  CREATE_NEW_FOLDER_MODAL_TITLE: { key: 'CREATE_NEW_FOLDER_MODAL_TITLE', value: 'New Folder' },
  CREATE_SUB_FOLDER_BUTTON: { key: 'CREATE_SUB_FOLDER_BUTTON', value: 'Create Subfolder' },
  UPDATE_FOLDER_MODAL_TITLE: { key: 'UPDATE_FOLDER_MODAL_TITLE', value: 'Update Folder' },
  FOLDER_CREATED_SUCCESS_MESSAGE: {
    key: 'FOLDER_CREATED_SUCCESS_MESSAGE',
    value: 'folder created successfully',
  },
  FOLDER_UPDATED_SUCCESS_MESSAGE: {
    key: 'FOLDER_UPDATED_SUCCESS_MESSAGE',
    value: 'folder updated successfully',
  },
  CREATE_FOLDER_BUTTON: { key: 'CREATE_FOLDER_BUTTON', value: 'Create' },
  CREATE_NEW_SUB_FOLDER_BUTTON: { key: 'CREATE_NEW_SUB_FOLDER_BUTTON', value: 'Create' },
  CREATING_NEW_FOLDER_BUTTON: { key: 'CREATING_NEW_FOLDER_BUTTON', value: 'Creating' },
  CREATING_NEW_SUB_FOLDER_BUTTON: { key: 'CREATING_NEW_SUB_FOLDER_BUTTON', value: 'Creating' },
  UPDATE_FOLDER_BUTTON: { key: 'UPDATE_FOLDER_BUTTON', value: 'Update' },
  UPDATING_FOLDER_BUTTON: { key: 'UPDATING_FOLDER_BUTTON', value: 'Updating' },
  HOME_ACTION: { key: 'HOME_ACTION', value: 'Home' },
  FOLDER_NAME_LABEL: { key: 'FOLDER_NAME', value: 'Folder Name' },
  FOLDER_NAME_PLACEHOLDER: { key: 'FOLDER_NAME_PLACEHOLDER', value: 'Name your folder' },
  SELECT_TEAM_LABEL: { key: 'SELECT_TEAM_LABEL', value: 'Select a team' },
  SELECT_TEAM_PLACEHOLDER: { key: 'SELECT_TEAM_PLACEHOLDER', value: 'Select a team' },
  PAGE_NUM: { key: 'PAGE_NUM', value: 'Page' },
  PAGES_NUM: { key: 'PAGES_NUM', value: 'Pages' },
  APPLY_ALL_PAGES: { key: 'APPLY_ALL_PAGES', value: 'Apply all pages' },
};

export const DESIGN_AREA_SETTINGS_TAB = {
  DISPLAY_NAME_LABEL: { key: 'DISPLAY_NAME_LABEL', value: 'Display Name' },
  DISPLAY_NAME_TOOLTIP: { key: 'DISPLAY_NAME_TOOLTIP', value: 'PDFs will be generated with this name.' },
  DISPLAY_NAME_MAX_LIMIT_WARNING_MESSAGE: { key: 'DISPLAY_NAME_MAX_LIMIT_WARNING_MESSAGE', value: 'The maximum allowed is 45 characters.' },
  DISPLAY_NAME_FETCH_FAIL_ERROR_MESSAGE: { key: 'DISPLAY_NAME_FETCH_FAIL_ERROR_MESSAGE', value: 'An error occurred while retrieving the display name.' },
  DISPLAY_NAME_UPDATE_FAIL_ERROR_MESSAGE: { key: 'DISPLAY_NAME_UPDATE_FAIL_ERROR_MESSAGE', value: 'An error occurred while updating the display name.' },
  DISPLAY_NAME_PLACEHOLDER: { key: 'DISPLAY_NAME_PLACEHOLDER', value: 'Enter display name' },
  PPI_UPDATE_ERROR: { key: 'PPI_UPDATE_ERROR', value: 'Error while updating ppi settings for document' },
  ACCESSIBILITY_SUMMARY: { key: 'ACCESSIBILITY_SUMMARY', value: 'Accessibility Summary' },
  ACCESSIBILITY_SUMMARY_TOOLTIP: { key: 'ACCESSIBILITY_SUMMARY_TOOLTIP', value: ' Provide a summary to enable screen reader users a quick understanding of the document before navigating through the contents in detail ' },

  FILE_NAME_CHANGE_CONFIRMATION: {
    key: 'FILE_NAME_CHANGE_CONFIRMATION',
    value: 'Are you sure to update the file name?',
  },
  SAVE_FILE_NAME_TOOLTIP: { key: 'SAVE_FILE_NAME_TOOLTIP', value: 'Save file name' },
  EDIT_FILE_NAME_TOOLTIP: {
    key: 'EDIT_FILE_NAME_TOOLTIP',
    value: 'Edit file name for generated document from template',
  },
  MANAGE_STUDIO_TITLE: { key: 'MANAGE_STUDIO_TITLE', value: 'Manage your studio' },
  ELEMENT_CATEGORY_TITLE: { key: 'ELEMENT_CATEGORY_TITLE', value: 'Elements Categories' },
  ELEMENT_CATEGORY_DESCRIPTION: {
    key: 'ELEMENT_CATEGORY_DESCRIPTION',
    value: 'Update or delete element categories.',
  },
  TEMPLATE_CATEGORY_TITLE: { key: 'TEMPLATE_CATEGORY_TITLE', value: 'Templates Categories' },
  TEMPLATE_CATEGORY_DESCRIPTION: {
    key: 'TEMPLATE_CATEGORY_DESCRIPTION',
    value: 'Update or delete template categories.',
  },
  FILES_TITLE: { key: 'FILES', value: 'Files' },
  FILES_DESCRIPTION: { key: 'FILES_DESCRIPTION', value: 'Select your file type' },
  ADD_NEW_CATEGORY_MODAL_TITLE: { key: 'ADD_NEW_CATEGORY_MODAL_TITLE', value: 'New category' },
  CANCEL_CREATE_NEW_CATEGORY_BUTTON: { key: 'CANCEL_CREATE_NEW_CATEGORY_BUTTON', value: 'Cancel' },
  SAVE_NEW_CATEGORY_BUTTON: { key: 'SAVE_NEW_CATEGORY_BUTTON', value: 'Save' },
  SAVING_NEW_CATEGORY_BUTTON: { key: 'SAVING_NEW_CATEGORY_BUTTON', value: 'Saving' },
  NEW_CATEGORY_NAME_LABEL: { key: 'NEW_CATEGORY_NAME_LABEL', value: 'Category Name' },
  NEW_CATEGORY_PLACEHOLDER: { key: 'NEW_CATEGORY_PLACEHOLDER', value: 'Name your category' },
  DELETE_CATEGORY_MODAL_TITLE: { key: 'DELETE_CATEGORY_MODAL_TITLE', value: 'Delete category' },
  CANCEL_DELETING_CATEGORY_BUTTON: { key: 'CANCEL_DELETING_CATEGORY_BUTTON', value: 'Cancel' },
  DELETING_CATEGORY_BUTTON: { key: 'DELETING_CATEGORY_BUTTON', value: 'Deleting' },
  DELETE_CATEGORY_BUTTON: { key: 'DELETE_CATEGORY_BUTTON', value: 'Delete' },
  UPDATE_CATEGORY_MODAL_TITLE: { key: 'UPDATE_CATEGORY_MODAL_TITLE', value: 'Edit category' },
  CANCEL_UPDATING_CATEGORY_BUTTON: { key: 'CANCEL_UPDATING_CATEGORY_BUTTON', value: 'Cancel' },
  SAVE_UPDATED_CATEGORY_BUTTON: { key: 'SAVE_UPDATED_CATEGORY_BUTTON', value: 'Save' },
  SAVING_UPDATED_CATEGORY_BUTTON: { key: 'SAVING_UPDATED_CATEGORY_BUTTON', value: 'Saving' },
  UPDATE_FILE_NAME_YES_BUTTON: { key: 'UPDATE_FILE_NAME_YES_BUTTON', value: 'Yes' },
  CANCEL_UPDATE_FILE_NAME_NO_BUTTON: { key: 'CANCEL_UPDATE_FILE_NAME_NO_BUTTON', value: 'No' },
  LOADING_SETTINGS: { key: 'LOADING_SETTINGS', value: 'Loading...' },
  CATEGORIES_LIST_EMPTY: {
    key: 'CATEGORIES_LIST_EMPTY',
    value: 'Categories list is empty. click ',
  },
  HERE: { key: 'HERE', value: 'here' },
  CREATE_NEW_CATEGORY: {
    key: 'CREATE_NEW_CATEGORY',
    value: 'to create category',
  },
  EDIT_CATEGORY_TOOLTIP: { key: 'EDIT_CATEGORY_TOOLTIP', value: 'Edit' },
  DELETE_CATEGORY_TOOLTIP: { key: 'DELETE_CATEGORY_TOOLTIP', value: 'Delete' },
  ADD_CATEGORY_BUTTON: { key: 'ADD_CATEGORY_BUTTON', value: 'Add Category' },
  DELETING: { key: 'DELETING', value: 'Deleting' },
  CATEGORY_DELETE_CONFIRMATION: {
    key: 'CATEGORY_DELETE_CONFIRMATION',
    value: 'Are you sure you wish to delete',
  },
  DELETE_CATEGORY: { key: 'DELETE_CATEGORY', value: 'category?' },
  PPI_LABEL: { key: 'PPI_LABEL', value: 'Ppi' },
  FONT_FAMILY: { key: 'FONT_FAMILY', value: 'Font Family' },
  FONT_SIZE: { key: 'FONT_SIZE', value: 'Font Size' },
  DOCUMENT_SUMMARY_LABEL: { key: 'DOCUMENT_SUMMARY_LABEL', value: 'Document Summary' },
  DOCUMENT_SUMMARY_TOOLTIP: { key: 'DOCUMENT_SUMMARY_TOOLTIP', value: 'Provide a short summary that helps screen readers explain this document.' },
  CLONEABLE_LABEL: {
    key: 'CLONEABLE_LABEL',
    value: 'Cloneable'
  },
  CLONEABLE_TOOLTIP: {
    key: 'CLONEABLE_TOOLTIP',
    value: 'Enable this option to allow on-demand customization of this template through interactive designs. Original design will remain unchanged.'
  },
  EDITABLE_ENABLE_FAIL_ERROR_MESSAGE: {
    key: 'EDITABLE_ENABLE_FAIL_ERROR_MESSAGE',
    value: 'An error occured while trying to enable cloneable. Please try again.',
  },
  EDITABLE_DISABLE_FAIL_ERROR_MESSAGE: {
    key: 'EDITABLE_DISABLE_FAIL_ERROR_MESSAGE',
    value: 'An error occured while trying to disable cloneable. Please try again.',
  },
  DISPLAY_NAME_MODAL_LABEL: { key: 'DISPLAY_NAME_MODAL_LABEL', value: 'Enter Display Name' },
  PDF_QUALITY_LABEL: { key: 'PDF_QUALITY_LABEL', value: 'PDF Quality'},
  PDF_QUALITY_TOOLTIP: { key: 'PDF_QUALITY_TOOLTIP', value: 'PDF will be generated with this rendering quality.'},
  ACCESSIBILITY_LABEL: { key: 'ACCESSIBILITY_LABEL', value: 'Accessibility'},
  ACCESSIBILITY_TOOLTIP: { key: 'ACCESSIBILITY_TOOLTIP', value: 'Accessibility is best for digital use of the PDFs. For only printing purposes, it is better to keep it off.'},
  PDF_QUALITY_CHANGE_FAIL_ERROR_MESSAGE: {
    key: 'PDF_QUALITY_CHANGE_FAIL_ERROR_MESSAGE',
    value: 'An error occured while trying to update PDF Quality. Please try again.',
  },
  ACCESSIBILITY_ENABLE_FAIL_ERROR_MESSAGE: {
    key: 'ACCESSIBILITY_ENABLE_FAIL_ERROR_MESSAGE',
    value: 'An error occured while trying to enable Accessibility. Please try again.',
  },
  ACCESSIBILITY_DISABLE_FAIL_ERROR_MESSAGE: {
    key: 'ACCESSIBILITY_DISABLE_FAIL_ERROR_MESSAGE',
    value: 'An error occured while trying to disable Accessibility. Please try again.',
  },
   DIGITAL_TITLE: {
    key: 'DIGITAL_TITLE',
    value: 'Digital (RGB)',
  },
  DIGITAL_DESC: {
    key: 'DIGITAL_DESC',
    value: 'Optimized for screen viewing and web distribution with vivid RGB colors. Images and barcodes remain at the resolution set in the document. Ideal for eBooks, reports, or any PDFs meant for digital use.',
  },
  PRINT_RGB_TITLE: {
    key: 'PRINT_RGB_TITLE',
    value: 'Print (RGB)',
  },
  PRINT_RGB_DESC: {
    key: 'PRINT_RGB_DESC',
    value: 'Suitable for printing with sharper output. Low-resolution images and barcodes are upgraded to high resolution. Maintains the RGB color space, compatible with most standard desktop printers.',
  },
  PRINT_CMYK_TITLE: {
    key: 'PRINT_CMYK_TITLE',
    value: 'Print (CMYK)',
  },
  PRINT_CMYK_DESC: {
    key: 'PRINT_CMYK_DESC',
    value: 'Designed for professional printing using CMYK color profile. Ensures accurate color reproduction for offset or large-scale print production. Colors may appear slightly duller on screen but are true to print.',
  },
  DESCRIPTION_SAVED: {
    key: 'DESCRIPTION_SAVED',
    value: 'Template description saved successfully'
  },
  DESCRIPTION_SAVE_FAILED: {
    key: 'DESCRIPTION_SAVE_FAILED',
    value: 'Template description couldn’t be saved. Please try again or contact support',
  },
  TEMPLATE_DESCRIPTION_LABEL: {
    key: 'TEMPLATE_DESCRIPTION_LABEL',
    value: 'Template Description',
  },
  DISPLAY_NAME_UNSUPPORTED_CHARS: {
    key: 'DISPLAY_NAME_UNSUPPORTED_CHARS',
    value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
  },
  BUSINESS_CONTRACT: { key: 'BUSINESS_CONTRACT', value: 'Business Contract' },
  BUSINESS_CONTRACT_ENABLE_DATA_MAPPING: { key: 'BUSINESS_CONTRACT_ENABLE_DATA_MAPPING', value: 'Enable data mapping' },
  BUSINESS_CONTRACT_ENABLE_DATA_MAPPING_TOOLTIP: { key: 'BUSINESS_CONTRACT_ENABLE_DATA_MAPPING_TOOLTIP', value: 'Enable data mapping to transform incoming business data according to the selected contract' },
  BUSINESS_CONTRACT_SELECT_CONTRACT: { key: 'BUSINESS_CONTRACT_SELECT_CONTRACT', value: 'Select business data contract' },
  BUSINESS_CONTRACT_SELECT_CONTRACT_TOOLTIP: { key: 'BUSINESS_CONTRACT_SELECT_CONTRACT_TOOLTIP', value: 'Choose a business contract that defines how incoming data should be transformed' },
  BUSINESS_CONTRACT_DESCRIPTION: { key: 'BUSINESS_CONTRACT_DESCRIPTION', value: 'Selected contract will transform incoming data to match your PDF template structure' },
  BUSINESS_CONTRACT_CONFIRM_TITLE: { key: 'BUSINESS_CONTRACT_CONFIRM_TITLE', value: 'Confirm Business Contract Change' },
  BUSINESS_CONTRACT_CONFIRM_MESSAGE: { key: 'BUSINESS_CONTRACT_CONFIRM_MESSAGE', value: 'Enabling business contract data mapping will affect transactions currently in progress. Any PDFs being generated may use the new data transformation rules. Are you sure you want to proceed?' },
  BUSINESS_CONTRACT_CONFIRM_BUTTON: { key: 'BUSINESS_CONTRACT_CONFIRM_BUTTON', value: 'Confirm' },
  BUSINESS_CONTRACT_CANCEL_BUTTON: { key: 'BUSINESS_CONTRACT_CANCEL_BUTTON', value: 'Cancel' },
  BUSINESS_CONTRACT_CHOOSE_PLACEHOLDER: { key: 'BUSINESS_CONTRACT_CHOOSE_PLACEHOLDER', value: 'Choose a contract...' },
  BUSINESS_CONTRACT_LOADING: { key: 'BUSINESS_CONTRACT_LOADING', value: 'Loading contracts...' },
  BUSINESS_CONTRACT_ERROR: { key: 'BUSINESS_CONTRACT_ERROR', value: 'An error occurred while processing your request. Please try again.' },
  BUSINESS_CONTRACT_MAPPED: { key: 'BUSINESS_CONTRACT_MAPPED', value: 'Business contract mapped successfully' },
  BUSINESS_CONTRACT_UNMAPPED: { key: 'BUSINESS_CONTRACT_UNMAPPED', value: 'Data mapping disabled successfully' },
  BUSINESS_CONTRACT_SELECT_REQUIRED: { key: 'BUSINESS_CONTRACT_SELECT_REQUIRED', value: 'Please select a contract to enable data mapping' },
  BUSINESS_CONTRACT_ALREADY_MAPPED: { key: 'BUSINESS_CONTRACT_ALREADY_MAPPED', value: 'This template is already mapped to a contract' },
  STYLING: { key: 'STYLING', value: 'Styling' },
  TAGS: { key: 'TAGS', value: 'Tags' },
  GENERAL: { key: 'GENERAL', value: 'General' },
  ACCESSIBILITY: { key: 'ACCESSIBILITY', value: 'Accessibility' },
  PDF_SETTINGS: { key: 'PDF_SETTINGS', value: 'PDF Settings' },
};

export const TEMPLATE_LOCKED_BY_MODAL = {
  TEMPLATE_LOCKED_MODAL_TITLE: { key: 'TEMPLATE_LOCKED_MODAL_TITLE', value: 'Template locked' },
  TEMPLATE_LOCKED: { key: 'TEMPLATE_LOCKED', value: 'This template was locked' },
  TEMPLATE_LOCKED_BY: { key: 'TEMPLATE_LOCKED_BY', value: 'by' },
  TEMPLATE_LOCKED_BY_TEMPLATE_NAME: {
    key: 'TEMPLATE_LOCKED_BY',
    value: 'Request {{templateName}} for edit access.',
  },
  OK_BUTTON: { key: 'OK_BUTTON', value: 'OK' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
};

export const REFERENCED_ELEMENTS_TAB = {
  LOADING_REFERENCED_ELEMENTS: { key: 'LOADING_REFERENCED_ELEMENTS', value: 'Loading...' },
  SEARCH_ELEMENTS_PLACEHOLDER: { key: 'SEARCH_ELEMENTS_PLACEHOLDER', value: 'Search Elements' },
  SEARCH_BY_CATEGORY_LABEL: { key: 'SEARCH_BY_CATEGORY_LABEL', value: 'By Category' },
  SEARCH_BY_CATEGORY_PLACEHOLDER: {
    key: 'SEARCH_BY_CATEGORY_PLACEHOLDER',
    value: 'Select Category',
  },
  CLEAR_ALL_FILTER_ACTION: { key: 'CLEAR_ALL_FILTER_ACTION', value: 'Clear All' },
  APPLY_FILTERS_BUTTON: { key: 'APPLY_FILTERS_BUTTON', value: 'Apply Filters' },
  ALL_CATEGORY_DROPDOWN_OPTION: { key: 'ALL_CATEGORY_DROPDOWN_OPTION', value: 'All' },
  SEE_ALL_ELEMENTS_ACTION: { key: 'SEE_ALL_TEMPLATES_ACTION', value: 'See All' },
  ELEMENTS_FOUND_COUNT: {
    key: 'ELEMENTS_FOUND_COUNT',
    value: 'We found {{elementsCount}} results based on your search',
  },
  ELEMENTS_LIST_EMPTY: { key: 'ELEMENTS_LIST_EMPTY', value: 'ELEMENTS list is empty. Use' },
  TEXT_ELEMENT: { key: 'TEXT_ELEMENT', value: 'Text' },
  TEXT_OR_IMAGE: { key: 'TEXT_OR_IMAGE', value: 'or' },
  IMAGE_UPLOAD: { key: 'IMAGE_UPLOAD', value: 'Upload' },
  CREATE_ELEMENTS: { key: 'CREATE_ELEMENTS', value: 'images to create elements' },
  GOT_ALL_RESULTS: { key: 'GOT_ALL_RESULTS', value: 'You have got all search results' },
  NO_ELEMENTS_AVAILABLE: { key: 'NO_ELEMENTS_AVAILABLE', value: 'No elements available' },
  REPLACE_ELEMENT_MODAL_TITLE: { key: 'REPLACE_ELEMENT_MODAL_TITLE', value: 'Replace element' },
  REPLACE_ELEMENT_YES_BUTTON: { key: 'REPLACE_ELEMENT_YES_BUTTON', value: 'Yes' },
  REPLACE_ELEMENT_NO_BUTTON: { key: 'REPLACE_ELEMENT_NO_BUTTON', value: 'No' },
  REPLACE_ELEMENT_CONFIRMATION: {
    key: 'REPLACE_ELEMENT_CONFIRMATION',
    value: 'Are you sure to replace the existing element ?',
  },
};

export const MASTER_ELEMENTS_TAB = {
  ELEMENTS_FOUND_COUNT: {
    key: 'ELEMENTS_FOUND_COUNT',
    value: 'Found {{elementsCount}} results based on your search',
  },
  CLEAR_ALL_FILTER_ACTION: { key: 'CLEAR_ALL_FILTER_ACTION', value: 'Clear All' },
  APPLY_FILTERS_BUTTON: { key: 'APPLY_FILTERS_BUTTON', value: 'Apply Filters' },
  ALL_CATEGORY_DROPDOWN_OPTION: { key: 'ALL_CATEGORY_DROPDOWN_OPTION', value: 'All' },
  SEARCH_ELEMENTS_PLACEHOLDER: {
    key: 'SEARCH_ELEMENTS_PLACEHOLDER',
    value: 'Search Master Elements',
  },
  SEARCH_BY_CATEGORY_LABEL: { key: 'SEARCH_BY_CATEGORY_LABEL', value: 'By Category' },
  SEARCH_BY_CATEGORY_PLACEHOLDER: {
    key: 'SEARCH_BY_CATEGORY_PLACEHOLDER',
    value: 'Select Category',
  },
  EMPTY_ELEMENTS_LABEL: { key: 'EMPTY_ELEMENTS_LABEL', value: 'No Element Available' },
};

export const EMAIL_SETTINGS_TAB = {
  CONFIRM_NEWLY_MAPPED_SMTP_FOR_PUBLISHED_TEMPLATE_TITLE: { key: 'CONFIRM_NEWLY_MAPPED_SMTP_FOR_PUBLISHED_TEMPLATE_TITLE', value: 'Changing the SMTP mapping for published template' },
  CONFIRM_NEWLY_MAPPED_SMTP_FOR_PUBLISHED_TEMPLATE_DESCRIPTION: { key: 'CONFIRM_NEWLY_MAPPED_SMTP_FOR_PUBLISHED_TEMPLATE_DESCRIPTION', value: 'Are you sure you want to proceed with this action?' },
  DECLINE_NEWLY_MAPPED_SMTP_BUTTON: { key: 'DECLINE_NEWLY_MAPPED_SMTP_BUTTON', value: 'No' },
  ACCEPT_NEWLY_MAPPED_SMTP_BUTTON: { key: 'ACCEPT_NEWLY_MAPPED_SMTP_BUTTON', value: 'Yes' },
  SEND_EMAIL_FROM_LABEL: { key: 'SEND_EMAIL_FROM_LABEL', value: 'Send email from' },
  SUBJECT_OF_EMAIL_LABEL: { key: 'SUBJECT_OF_EMAIL_LABEL', value: 'Subject of Email' },
  SUBJECT_OF_EMAIL_PLACEHOLDER: { key: 'SUBJECT_OF_EMAIL_PLACEHOLDER', value: 'Subject of Email' },
  DELETE_ATTACHMENT_DROPDOWN_ACTION: { key: 'DELETE_ATTACHMENT_DROPDOWN_ACTION', value: 'Delete' },
  ADD_TEMPLATE_AS_ATTACHMENT_BUTTON: { key: 'ADD_TEMPLATE_AS_ATTACHMENT_BUTTON', value: 'Add Attachment' },
  EXTERNAL_DROPDOWN_OPTION: { key: 'EXTERNAL_DROPDOWN_OPTION', value: 'External' },
}

export const EMAIL_ELEMENT_TAB_DETAILS = {
  LOADING_TEXT: { key: 'LOADING_TEXT', value: 'Loading...' },
  SEARCH_ELEMENTS_PLACEHOLDER: { key: 'SEARCH_ELEMENTS_PLACEHOLDER', value: 'Search Elements' },
  CLEAR_ALL_FILTERS_ACTION: { key: 'CLEAR_ALL_FILTERS_ACTION', value: 'Clear All' },
  ALL_CATEGORY_DROPDOWN_OPTION: { key: 'ALL_CATEGORY_DROPDOWN_OPTION', value: 'All' },
  APPLY_FILTER_BUTTON: { key: 'APPLY_FILTER_BUTTON', value: 'Apply Filters' },
  ELEMENTS_LIST: { key: 'ELEMENTS_LIST', value: 'Elements list is empty. Use ' },
  SEARCH_RESULT_MESSAGE: { key: 'RESULT', value: 'We found {{Count}} results based on your search ' },
  EMPTY_VIEW_TEXT: { key: 'EMPTY_VIEW_TEXT', value: 'Text' },
  EMPTY_VIEW_UPLOAD_TEXT: { key: 'EMPTY_VIEW_UPLOAD_TEXT', value: 'Upload' },
  CREATE_ELEMENT: { key: 'CREATE_ELEMENT', value: 'images to create elements' },
  DELETE_ELEMENT_DROPDOWN_OPTION: { key: 'DELETE_ELEMENT_DROPDOWN_OPTION', value: 'Delete' },
  MANAGE_TAG_DROPDOWN_OPTION: { key: 'MANAGE_TAG_DROPDOWN_OPTION', value: ' Manage Tags' },
  SEE_ALL_ELEMENTS_ACTION: { key: 'SEE_ALL_ELEMENTS_ACTION', value: 'See All' },
  NO_ELEMENTS: { key: 'NO_ELEMENTS', value: 'No Elements available' },
  SEARCH_RESULT: { key: 'SEARCH_RESULT', value: 'You have got all search results' },
  OR: { key: 'OR', value: 'or' },
  REUSABLE_TAB_LABEL: { key: 'REUSABLE_TAB_LABEL', value: 'Reusables' },
  MASTER_TAB_LABEL: { key: 'MASTER_TAB_LABEL', value: 'Master' },
  REFERENCED_TAB_LABEL: { key: 'REFERENCED_TAB_LABEL', value: 'Referenced' },
};

export const EMAIL_TEMPLATE_TAB_DETAILS = {
  SEARCH_TEMPLATE_PLACEHOLDER: { key: 'SEARCH_TEMPLATE_PLACEHOLDER', value: 'Search Templates' },
  CLEAR_ALL_FILTERS_ACTION: { key: 'CLEAR_ALL_FILTERS_ACTION', value: 'Clear All' },
  SELECT_CATEGORY_PLACEHOLDER: { key: 'SELECT_CATEGORY_PLACEHOLDER', value: 'Select Category' },
  ALL_CATEGORY_DROPDOWN_OPTION: { key: 'ALL_CATEGORY_DROPDOWN_OPTION', value: 'All' },
  APPLY_FILTER_BUTTON: { key: 'APPLY_FILTER_BUTTON', value: 'Apply Filters' },
  SEARCH_RESULT_MESSAGE: { key: 'RESULT', value: 'We found {{Count}} results based on your search ' },
  ALT: { key: 'ALT', value: 'EmptyElementsIllustration' },
  TEMPLATE_EMPTY_LIST: { key: 'EMPTY_LIST', value: 'Templates list is empty. ' },
  CLICK: { key: 'CLICK', value: 'Click' },
  HERE: { key: 'HERE', value: 'here' },
  CREATE_NEW_EMAIL_TEMPLATE: { key: 'CREATE_NEW_EMAIL_TEMPLATE', value: 'to create new template' },
  SEE_ALL_TEMPLATES_ACTION: { key: 'SEE_ALL_TEMPLATES_ACTION', value: 'See All' },
  EDIT_DROPDOWN_OPTION: { key: 'EDIT_DROPDOWN_OPTION', value: 'Edit' },
  DELETE_DROPDOWN_OPTION: { key: 'DELETE_DROPDOWN_OPTION', value: 'Delete' },
  MANAGE_TAG_DROPDOWN_OPTION: { key: 'MANAGE_TAG_DROPDOWN_OPTION', value: ' Manage Tags' },
  PAGE: { key: 'PAGE', value: 'Page' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  OK_BUTTON: { key: 'OK_BUTTON', value: 'OK' },
  TEMPLATE: { key: 'TEMPLATE', value: 'This template was locked' },
  BY: { key: 'BY', value: 'by' },
  REQUEST: { key: 'REQUEST', value: 'Request' },
  EDIT_ACCESS: { key: 'EDIT_ACCESS', value: 'for edit access.' },
  CREATE_NEW_TEMPLATE_BUTTON: { key: 'CREATE_NEW_TEMPLATE_BUTTON', value: 'Create New Template.' },
  NO_TEMPLATE_MESSAGE: { key: 'NO_TEMPLATE_MESSAGE', value: 'No templates available.' },
  SEARCH_RESULT: { key: 'SEARCH_RESULT', value: 'You have got all search results' },
  LOADING_TEXT: { key: 'LOADING_TEXT', value: 'Loading...' },
  TEMPLATE_LOCK_TITLE: { key: 'TEMPLATE_LOCK_TITLE', value: 'Template locked' },
  PREVIEW_TOOLTIP: { key: 'PREVIEW_TOOLTIPvalue', value: 'Preview' },
  FILTER_BY_CATEGORY_TITLE: { key: "FILTER_BY_CATEGORY_TITLE", value: 'By Category' },
  REPLACE_TEMPLATE_NO_BUTTON: { key: "REPLACE_TEMPLATE_NO_BUTTON", value: 'NO' },
  REPLACE_TEMPLATE_YES_BUTTON: { key: "REPLACE_TEMPLATE_YES_BUTTON", value: 'YES' },
  REPLACE_EXISTING_TEMPLATE_WARNING_MESSAGE: { key: "REPLACE_EXISTING_TEMPLATE_WARNING_MESSAGE", value: 'YES' },
  REPLACE_TEMPLATE_TITLE: { key: "REPLACE_TEMPLATE_TITLE", value: 'Replace template' },
  MY_DESIGN_TAB_LABEL: { key: 'MY_DESIGN_TAB_LABEL', value: 'My designs' },
  MASTER_TAB_LABEL: { key: 'MASTER_TAB_LABEL', value: 'Master' },
};

export const DESIGN_AREA_FLOW_BLOCK_TAB = {
  REUSE_SECTION_TAB_TITLE: { key: 'REUSE_SECTION_TAB_TITLE', value: 'Reuse Sections' },
  REUSE_PAGE_TAB_TITLE: { key: 'REUSE_PAGE_TAB_TITLE', value: 'Reuse Pages' },
  REUSE_INSERTS_TITLE: { key: 'REUSE_INSERTS_TITLE', value: 'Reuse Inserts' },
  CREATE_NEW_REUSABLE_PAGES_BUTTON: { key: 'CREATE_NEW_REUSABLE_PAGES_BUTTON', value: 'Create New reusable pages' },
  CREATE_NEW_REUSABLE__SECTION_BUTTON: { key: 'CREATE_NEW_REUSABLE__SECTION_BUTTON', value: 'Create New reusable section' },
  SEARCH_TEMPLATES_PLACEHOLDER: { key: 'SEARCH_TEMPLATES_PLACEHOLDER', value: 'Search Templates' },
  SEARCH_INSERTS_PLACEHOLDER: { key: 'SEARCH_INSERTS_PLACEHOLDER', value: 'Search Inserts' },
  SEARCH_BY_CATEGORY_LABEL: { key: 'SEARCH_BY_CATEGORY_LABEL', value: 'By Category' },
  CLEAR_ALL_FILTER_ACTION: { key: 'CLEAR_ALL_FILTER_ACTION', value: 'Clear All' },
  APPLY_FILTERS_BUTTON: { key: 'APPLY_FILTERS_BUTTON', value: 'Apply Filters' },
  ALL_CATEGORY_DROPDOWN_OPTION: { key: 'ALL_CATEGORY_DROPDOWN_OPTION', value: 'All' },
  SEE_ALL_TEMPLATES_ACTION: { key: 'SEE_ALL_TEMPLATES_ACTION', value: 'See All' },
  TEMPLATES_FOUND_COUNT: {
    key: 'TEMPLATES_FOUND_COUNT',
    value: 'We found {{templatesCount}} results based on your search',
  },
  TEMPLATES_LIST_EMPTY: { key: 'TEMPLATES_LIST_EMPTY', value: 'Templates list is empty.' },
  CLICK: { key: 'CLICK', value: 'Click' },
  HERE: { key: 'HERE', value: 'here' },
  EMPTY_LIST_CREATE_NEW_TEMPLATE: {
    key: 'EMPTY_LIST_CREATE_NEW_TEMPLATE',
    value: 'to create new template',
  },
  TEMPLATE_EDIT_DROPDOWN_OPTION: { key: 'TEMPLATE_EDIT_DROPDOWN_OPTION', value: 'Edit' },
  TEMPLATE_DELETE_DROPDOWN_OPTION: { key: 'TEMPLATE_DELETE_DROPDOWN_OPTION', value: 'Delete' },
  TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION: {
    key: 'TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION',
    value: 'Manage Tags',
  },
  TEMPLATE_PREVIEW_TOOLTIP: { key: 'TEMPLATE_PREVIEW_TOOLTIP', value: 'Preview' },
  LOADING_MORE_TEMPLATES_TEXT: { key: 'LOADING_MORE_TEMPLATES_TEXT', value: 'Loading...' },
  APPLY_ALL_PAGES_BUTTON: { key: 'APPLY_ALL_PAGES_BUTTON', value: 'Apply all pages' },
  PAGE_NUMBER_LABEL: { key: 'PAGE_NUMBER_LABEL', value: 'Page {{PageNum}} of' },
  PAGE_NUM: { key: 'PAGE_NUM', value: 'Page' },
  GOT_ALL_RESULTS: { key: 'GOT_ALL_RESULTS', value: 'You have got all search results' },
  NO_TEMPLATES_AVAILABLE: { key: 'NO_TEMPLATES_AVAILABLE', value: 'No templates available' },
  TEMPLATE_EDITED_ON: { key: 'TEMPLATE_EDITED_ON', value: 'Edited on ' },
  FAILED_TO_PERFORM_ERROR_MESSAGE: { key: "FAILED_TO_PERFORM_ERROR_MESSAGE", value: "Failed to Perform Operation. Please try again" },
  FETCHING_RECORDS_ERROR_MESSAGE: {
    key: 'FETCHING_RECORDS_ERROR_MESSAGE',
    value: 'Error Fetching records. Please try again or contact support.'
  },
  BLOCK_DELETED_SUCCESS_MESSAGE: {
    key: 'BLOCK_DELETED_SUCCESS_MESSAGE',
    value: 'The reusable section has been successfully deleted.'
  },
  BLOCK_CANNOT_DELETE_ERROR_MESSAGE: {
    key: 'BLOCK_CANNOT_DELETE_ERROR_MESSAGE',
    value: 'This reusable block cannot be deleted because it is currently in use within a template.'
  },
  BLOCK_DELETE_FAILED_ERROR_MESSAGE: {
    key: 'BLOCK_DELETE_FAILED_ERROR_MESSAGE',
    value: 'An error occurred while attempting to delete the reusable section.'
  },
  DELETE_BUTTON: { key: 'DELETE_BUTTON', value: 'Delete' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  DELETE_CONFIRM_MESSAGE: {
    key: 'DELETE_CONFIRM_MESSAGE',
    value: 'Are you certain you want to delete this reusable section'
  },
  SELECT_CATEGORY_PLACEHOLDER: { key: 'SELECT_CATEGORY_PLACEHOLDER', value: 'Select Category' },
};

export const COMPLEX_DOC_LOGO_HEADER = {
  DOCUMENT_TITLE: { key: 'DOCUMENT_TITLE', value: 'DOCUMENT' },
  REUSABLE_PAGE_TITLE: { key: 'REUSABLE_PAGE_TITLE', value: 'REUSABLE PAGE' },
  REUSABLE_SECTION_TITLE: { key: 'REUSABLE_SECTION_TITLE', value: 'REUSABLE SECTION' },
};

export const SIDEBAR_PREVIEW_MODAL = {
  TEMPLATE_EDITED_ON: { key: 'TEMPLATE_EDITED_ON', value: 'Edited on ' },
}

export const ADD_EMAIL_ATTACHMENT_MODAL = {
  EDITABLE_TEMPLATE_TOOLTIP: { key: 'EDITABLE_TEMPLATE_TOOLTIP', value: 'Editable Template'}
}
